import {Component, inject} from '@angular/core';
import {UsersService} from "../../services/users.service";
import {UIStateEnum} from "../../enum/UIStateEnum";
import {ISendPasswordRecoveryEmailRequest} from "../../interfaces/ISendPasswordRecoveryEmailRequest";
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {AppConfigService} from "../../services/app-config.service";
import {ErrorHandlingService} from "../../services/error-handling.service";
import {MatCardModule} from "@angular/material/card";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInput} from "@angular/material/input";
import {ReCaptchaV3Service, RecaptchaV3Module, RECAPTCHA_V3_SITE_KEY} from "ng-recaptcha";
import {MatButton} from "@angular/material/button";

@Component({
  selector: 'app-recover-password',
  standalone: true,
  templateUrl: './recover-password.component.html',
  imports: [
    MatCardModule,
    MatFormFieldModule,
    MatInput,
    ReactiveFormsModule,
    RecaptchaV3Module,
    MatButton
  ],
  styleUrls: ['./recover-password.component.css']
})
export class RecoverPasswordComponent {

  private userService: UsersService = inject(UsersService);
  private errorHandlingService: ErrorHandlingService = inject(ErrorHandlingService);
  private recaptchaV3Service: ReCaptchaV3Service = inject(ReCaptchaV3Service);

  public showCheckEmailMessage: boolean = false;
  public recoverPasswordForm = new FormGroup({
    recoverPasswordEmail: new FormControl<string>('', Validators.required)
  });
  public uiState: UIStateEnum = UIStateEnum.ShowData;
  public uiStateForTemplate = UIStateEnum;

  sendPasswordRecoveryEmail() {
    if (!this.recoverPasswordForm.valid) {
      this.recoverPasswordForm.markAllAsTouched();
      return;
    }

    this.uiState = UIStateEnum.ShowLoading;

    this.recaptchaV3Service.execute('recover_password').subscribe({
      next: (token) => {
        const recoverPasswordRequest: ISendPasswordRecoveryEmailRequest = {
          email: this.recoverPasswordForm.controls.recoverPasswordEmail.value!,
          redirectUrl: `${window.location.origin}/login`,
          captcha: token,
          isAdminReset: true
        }
        this.userService.sendPasswordRecoveryEmail(recoverPasswordRequest).subscribe({
          next: () => this.showCheckEmailMessage = true,
          error: (err) => {
            this.uiState = UIStateEnum.ShowData;
            this.errorHandlingService.displayPageLevelErrorMessage(err);
          }
        })
      },
      error: () => {
        this.uiState = UIStateEnum.ShowData;
        this.errorHandlingService.displayPageLevelErrorMessage({
          error: { message: 'We couldn\'t process your password recovery request. Please try again or contact support.' }
        });
      }
    });
  }
}
